import React, { useState, useRef, useEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SbEditable from 'storyblok-react'

gsap.registerPlugin(ScrollTrigger)

const useCountUp = (bigNumbersElement) => {
  const refCountUpTrigger = useRef(null)
  const refCountUp = useRef([])
  refCountUp.current = []

  const refCountUpCollection = (el) => {
    if (el && !refCountUp.current.includes(el)) {
      refCountUp.current.push(el)
    }
  }

  useEffect(() => {
    if (bigNumbersElement) {
    gsap.from(refCountUp.current, {
      duration: 1,
      //stagger: 0.25,
      ease: 'ease.out',
      innerText: 0,
      snap: { innerText: 1 },
      scrollTrigger: {
        trigger: refCountUpTrigger.current,
        toggleActions: 'play none none none',
        start: 'start 75%',
        end: 'bottom 25%',
      },
    })
  }
  }, [bigNumbersElement])
  return [refCountUpTrigger, refCountUpCollection]
}

const BigNumbersBlock = ({ block }) => {
  const [bigNumbersElement, setBigNumbersElement] = useState(null)
  const [refCountUpTrigger, refCountUpCollection] = useCountUp(bigNumbersElement)

  return (
    <SbEditable content={block}>
      <section
        ref={setBigNumbersElement}
        className="big-numbers-block"
        data-rellax-center={true}
        data-rellax-speed={1}
      >
        <div className="big-numbers-block-container" ref={refCountUpTrigger}>
          <div
            className="big-numbers-block-wrapper"
            data-rellax-center={true}
            data-rellax-speed={-1}
          >
            <div className="big-numbers-block-row">
              <div className="big-numbers-block-header">
                <h2>{block.headline}</h2>
                <div className="h2-subheadline">{block.subheadline}</div>
              </div>
              {block.big_numbers?.length > 0 &&
                block.big_numbers.map((item, index) => (
                  <div className="big-numbers-block-item" key={index}>
                    <h3>
                      <div className="big-numbers-block-item-number">
                        <div className="big-numbers-block-item-number-prefix">
                          {item.prefix}
                        </div>
                        <div
                          className="big-numbers-block-item-number-counter"
                          ref={refCountUpCollection}
                        >
                          {item.number}
                        </div>
                      </div>
                      <div className="big-numbers-block-item-label">
                        {item.title}
                      </div>
                    </h3>
                    <div className="h3-subheadline">{item.subtitle}</div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default BigNumbersBlock
